import { getCurrentUser } from "@aws-amplify/auth";
import { configureAuth, getConfiguredAuthType } from "./authConfig";
import { getPreferredAuthType, persistAuthType } from "./authTypeStorage";
import { withSessionLock } from "./sessionQueue";

const OTHER_TYPE = {
  author: "reader",
  reader: "author",
};

export const resolveSessionAcrossPools = ({ persist = true, read } = {}) => withSessionLock(async () => {
  const preferred = getPreferredAuthType();
  const probeOrder = [preferred, OTHER_TYPE[preferred]].filter(Boolean);

  for (const type of probeOrder) {
    try {
      configureAuth(type);
      const user = await getCurrentUser();

      if (persist) {
        persistAuthType(type);
      }

      const data = read ? await read() : undefined;
      return { user, type, data };
    } catch {
      // Keep probing until one pool resolves.
    }
  }

  return null;
});



export const resolveSessionForType = (type, { persist = false, read, restore = false } = {}) => withSessionLock(async () => {
  if (!type) {
    throw new Error("resolveSessionForType requires a portal type");
  }

  const previousType = getConfiguredAuthType() || getPreferredAuthType();
  try {
    configureAuth(type);
    const user = await getCurrentUser();
    const data = read ? await read() : undefined;
    if (persist) persistAuthType(type);
    return { user, type, data };
  } finally {
    if (restore) configureAuth(previousType);
  }
});
